import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "d-flex align-items-center mb-2" }
const _hoisted_10 = { class: "text-gray-800  fs-2 fw-bolder me-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { href: "#" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_15 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_16 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_17 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_18 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_19 = { class: "d-flex flex-wrap" }
const _hoisted_20 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = {
  class: "fw-bold fs-6 text-gray-400",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_23 = { class: "fs-2 fw-bolder" }
const _hoisted_24 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = {
  class: "fw-bold fs-6 text-gray-400",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_27 = { class: "fs-2 fw-bolder" }
const _hoisted_28 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = {
  class: "fw-bold fs-6 text-gray-400",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_31 = { class: "fs-2 fw-bolder" }
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = {
  class: "fw-bold fs-6 text-gray-400",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "fs-2 fw-bolder" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-muted svg-icon-2hx" }, [
      /*#__PURE__*/_createVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1"
      }, [
        /*#__PURE__*/_createVNode("g", {
          stroke: "none",
          "stroke-width": "1",
          fill: "none",
          "fill-rule": "evenodd"
        }, [
          /*#__PURE__*/_createVNode("polygon", { points: "0 0 24 0 24 24 0 24" }),
          /*#__PURE__*/_createVNode("path", {
            d: "M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z",
            fill: "#000000",
            "fill-rule": "nonzero",
            opacity: "0.3"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M14.8875071,11.8306874 L12.9310336,11.8306874 L12.9310336,9.82301606 C12.9310336,9.54687369 12.707176,9.32301606 12.4310336,9.32301606 L11.4077349,9.32301606 C11.1315925,9.32301606 10.9077349,9.54687369 10.9077349,9.82301606 L10.9077349,11.8306874 L8.9512614,11.8306874 C8.67511903,11.8306874 8.4512614,12.054545 8.4512614,12.3306874 C8.4512614,12.448999 8.49321518,12.5634776 8.56966458,12.6537723 L11.5377874,16.1594334 C11.7162223,16.3701835 12.0317191,16.3963802 12.2424692,16.2179453 C12.2635563,16.2000915 12.2831273,16.1805206 12.3009811,16.1594334 L15.2691039,12.6537723 C15.4475388,12.4430222 15.4213421,12.1275254 15.210592,11.9490905 C15.1202973,11.8726411 15.0058187,11.8306874 14.8875071,11.8306874 Z",
            fill: "#000000"
          })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_35 = { class: "row mb-6" }
const _hoisted_36 = { class: "col-lg-6 col-form-label required fw-bold fs-6" }
const _hoisted_37 = { class: "col-lg-6 fv-row" }
const _hoisted_38 = /*#__PURE__*/_createVNode("option", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "fv-plugins-message-container" }, [
  /*#__PURE__*/_createVNode("div", { class: "fv-help-block" })
], -1)
const _hoisted_40 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_41 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_42 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Dropdown3 = _resolveComponent("Dropdown3")
  const _component_Field = _resolveComponent("Field")
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                src: `media/stock/600x400/${_ctx.device['device']}.png`,
                alt: "image"
              }, null, 8, ["src"]),
              _createVNode("div", {
                class: `position-absolute translate-middle bottom-0 start-100 mb-6 ${_ctx.device['status']=='connected'? 'bg-success': 'bg-danger'} rounded-circle border border-4 border-white h-20px w-20px`
              }, null, 2)
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("a", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.device["MAC"]) + " ", 1),
                    (_ctx.device.vendorInfo)
                      ? (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString(_ctx.translate("vendor")) + ": " + _toDisplayString(_ctx.device["vendorInfo"].name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("a", _hoisted_12, [
                    _createVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Verified.svg" })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("a", _hoisted_15, [
                    _createVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Clip.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.device['fwName']), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, _toDisplayString(_ctx.translate("model")), 1)
                    ]),
                    _createVNode("div", _hoisted_23, _toDisplayString(_ctx.device.device), 1)
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _createVNode("div", _hoisted_26, _toDisplayString(_ctx.translate("softwarev")), 1)
                    ]),
                    _createVNode("div", _hoisted_27, _toDisplayString(_ctx.device['version']), 1)
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _createTextVNode(_toDisplayString(_ctx.translate("modwifi")) + " ", 1),
                        _createVNode(_component_Dropdown3)
                      ])
                    ]),
                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.device['wifiModule']), 1)
                  ]),
                  _createVNode("div", {
                    class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3",
                    style: {"cursor":"pointer"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectPDF && _ctx.redirectPDF(...args)))
                  }, [
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", _hoisted_33, _toDisplayString(_ctx.translate("downldocumentation")), 1)
                    ]),
                    _hoisted_34
                  ]),
                  _createVNode("div", _hoisted_35, [
                    _createVNode("label", _hoisted_36, _toDisplayString(_ctx.translate("vendor")), 1),
                    _createVNode("div", _hoisted_37, [
                      _createVNode(_component_Field, {
                        as: "select",
                        class: "form-select form-select-solid form-select-lg",
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChange($event))),
                        modelValue: _ctx.selected,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selected = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.vendors, (value, key) => {
                            return (_openBlock(), _createBlock("option", {
                              key: key,
                              value: value.vendorId
                            }, _toDisplayString(value.vendorInfo.name), 9, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_39
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_40, [
          _createVNode("ul", _hoisted_41, [
            _createVNode("li", _hoisted_42, [
              _createVNode(_component_router_link, {
                to: {
                name: 'device-records',
                params: {
                  mac: _ctx.device['MAC'],
                  id: _ctx.device['_id'],
                  model: _ctx.device['device'],
                  records: JSON.stringify(_ctx.device['registers'])
                }
              },
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("records")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}